var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FDB75A21-0203-4AD0-A4AD-26DCC4D649A2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0001 0.0002 60 0.0002 60 60 0.0001 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0001 0.0002 60 0.0002 60 60 0.0001 60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Help-Page_V3",
    transform: "translate(-545.000000, -901.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(513.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001,0.0002 C13.4311,0.0002 0.0001,13.4312 0.0001,30.0002 C0.0001,46.5687 13.4311,60.0002 30.0001,60.0002 C46.5686,60.0002 60.0001,46.5687 60.0001,30.0002 C60.0001,13.4312 46.5686,0.0002 30.0001,0.0002 M30.0001,1.5002 C45.7151,1.5002 58.5001,14.2847 58.5001,30.0002 C58.5001,45.7152 45.7151,58.5002 30.0001,58.5002 C14.2851,58.5002 1.5001,45.7152 1.5001,30.0002 C1.5001,14.2847 14.2851,1.5002 30.0001,1.5002",
    id: "Fill-1",
    fill: "#EDEBE9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001,0.0002 C13.4311,0.0002 0.0001,13.4312 0.0001,30.0002 C0.0001,46.5687 13.4311,60.0002 30.0001,60.0002 C46.5686,60.0002 60.0001,46.5687 60.0001,30.0002 C60.0001,13.4312 46.5686,0.0002 30.0001,0.0002 M30.0001,1.5002 C45.7151,1.5002 58.5001,14.2847 58.5001,30.0002 C58.5001,45.7152 45.7151,58.5002 30.0001,58.5002 C14.2851,58.5002 1.5001,45.7152 1.5001,30.0002 C1.5001,14.2847 14.2851,1.5002 30.0001,1.5002",
    id: "Fill-4",
    fill: "#EDEBE9",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-7",
    stroke: "#05314D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "45.3761 42.58565 20.7906 42.58565 17.1401 11.38165 41.7256 11.38165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.14025,11.38155 C17.14025,11.38155 14.25175,12.83755 14.66425,17.41405 L18.17175,48.61905 C17.75925,44.04205 20.64775,42.58555 20.64775,42.58555",
    id: "Stroke-9",
    stroke: "#05314D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#05314D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "18.17175 48.61885 42.44075 48.61885 45.37625 42.58585"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.6959,
    y1: 45.60225,
    x2: 24.5164,
    y2: 45.60225,
    id: "Stroke-13",
    stroke: "#05314D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.1681,
    y1: 47.12325,
    x2: 21.3696,
    y2: 47.12325,
    id: "Stroke-15",
    stroke: "#05314D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.5587,
    y1: 44.2653,
    x2: 36.4832,
    y2: 44.2653,
    id: "Stroke-17",
    stroke: "#05314D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.adaaef2c05d83c59cb58e9ff93655046.svg";
export { ForwardRef as ReactComponent };